import { render, staticRenderFns } from "./trans.vue?vue&type=template&id=f3b7e3d6&"
import script from "./trans.vue?vue&type=script&lang=js&"
export * from "./trans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports